import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, Eyebrow } from "@/components/Motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const IMG = "/journal/river-gorge.webp";

export default function NewsletterSection() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/newsletter`, { email: email.trim() });
            toast.success(data.message);
            if (!data.already) setEmail("");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Something went wrong — try again");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="relative overflow-hidden" data-testid="newsletter-section">
            <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0B1320] via-[#0B1320]/60 to-[#0B1320]" />

            <div className="relative max-w-4xl mx-auto px-5 sm:px-8 py-24 sm:py-32 text-center">
                <Reveal>
                    <Eyebrow className="text-center">The Field Journal</Eyebrow>
                    <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-100">
                        One dispatch a week. Hatches, flows, and the gear that matters.
                    </h2>
                    <p className="mt-4 font-body text-base text-slate-400 max-w-xl mx-auto">
                        No spam, no fluff — just what is hatching, where the water is moving, and one tip worth practicing before Saturday.
                    </p>
                </Reveal>

                <Reveal delay={0.15}>
                    <form onSubmit={submit} data-testid="newsletter-form" className="mt-10 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@riverbank.com"
                            data-testid="newsletter-email-input"
                            className="flex-1 rounded-full border border-white/15 bg-[#0B1320]/80 backdrop-blur px-6 py-4 font-body text-sm text-slate-100 placeholder:text-slate-500 outline-none focus:border-teal/60 transition-colors"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="newsletter-submit-button"
                            className="rounded-full bg-teal px-8 py-4 font-sans text-sm font-semibold text-[#0B1320] hover:bg-coral hover:text-white disabled:opacity-60 transition-colors duration-300"
                        >
                            {loading ? "Casting..." : "Join the Journal"}
                        </button>
                    </form>
                </Reveal>
            </div>
        </section>
    );
}
